import { useEffect, useState } from 'react';

export const useClassTimer = (start) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!start) return;
    const interval = setInterval(() => {
      setSeconds(Math.floor((Date.now() - start) / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, [start]);

  const format = () => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return [h, m, s]
      .map((n) => String(n).padStart(2, '0'))
      .join(':');
  };

  return { seconds, formatted: format() };
};
